export let SIZE_OPTIONS = /*#__PURE__*/function (SIZE_OPTIONS) {
  SIZE_OPTIONS["SMALL"] = "small";
  SIZE_OPTIONS["NORMAL"] = "normal";
  return SIZE_OPTIONS;
}({});
export let RESIZE_OPTIONS = /*#__PURE__*/function (RESIZE_OPTIONS) {
  RESIZE_OPTIONS["VERTICAL"] = "vertical";
  RESIZE_OPTIONS["NONE"] = "none";
  return RESIZE_OPTIONS;
}({});